"use client";

import classNames from "classnames";
import { FC, ReactNode, useEffect, useState } from "react";

interface Props {
  children: ReactNode;
  noMinHeight?: boolean;
  customBg?: string;
}

/**
 *
 * @param noMinHeight by default will apply min-h-dvh
 * @param customBg custom bg to apply, otherwise white is default
 */
const Main: FC<Props> = ({ children, noMinHeight, customBg }) => {
  const [pagePath, setPagePath] = useState("");

  useEffect(() => {
    const pathName = window?.location.pathname ?? "";
    if (pathName.indexOf("projects") >= 0) {
      setPagePath("project-property-page");
    }
    if (pathName.indexOf("communities") >= 0) {
      setPagePath("community-page");
    }
  }, []);
  /* TODO why z-index on main? */
  return <main className={classNames("z-10 flex-grow", { "min-h-dvh": !noMinHeight }, customBg ?? "bg-white", pagePath)}>{children}</main>;
};
export default Main;
